export enum CampaingStatusSteps {
    // Step 1 texts
    CampaignReceived = 'Campaign Received',
    // Step 2 texts
    AdsUploaded = 'Ads Uploaded',
    AdsMissing = 'Ads Missing',
    // Step 3 or 4 texts (swap based on budget)
    PaymentReceived = 'Payment Received',
    MediaPlanCreated = 'Media Plan Created',
    MediaPlanAccepted = 'Media Plan Accepted',
    MediaPlanReady = 'Media Plan Ready to View',
    // Step 5 texts
    AwaitingAdsApproval = 'Awaiting Ads Approval',
    AdsApproved = 'Ads Approved',
    AdsRejected = 'Ads Rejected',
    // Step 6 texts
    CampaignApproved = 'Campaign Approved',


}